export default __webpack_public_path__ + "static/media/Arrow 1.bde62473.svg";